module.exports = __webpack_public_path__ + "img/assembly_1.asm.0d8a4100.jpg";